// Hindi translations — RajDarshan Tandon Dairy
// Loaded lazily only when user selects Hindi

const hi = {
    // Header
    home: "होम",
    about: "हमारे बारे में",
    purity: "शुद्धता",
    contact: "संपर्क करें",

    // Language Popup
    languageTitle: "अपनी भाषा चुनें",
    languageSubtitle: "जारी रखने के लिए अपनी पसंदीदा भाषा चुनें",
    hindi: "हिंदी",
    english: "English",
    continue: "जारी रखें",

    // Hero Section
    heroTitle: "शुद्ध दूध, सीधे हमारे परिवार से आपके घर तक",
    heroSubtitle: "तीन पीढ़ियों का विश्वास। शून्य रसायन। बस शुद्ध, उच्च प्रोटीन दूध पारंपरिक स्टील के कनस्तरों में रायपुर भर में पहुंचाया जाता है।",
    heroHighlight: "1969 से 500+ परिवारों की सेवा कर रहे हैं",
    ctaCall: "सब्सक्रिप्शन के लिए कॉल करें",
    ctaWhatsapp: "व्हाट्सएप पर मैसेज करें",

    // About Section
    aboutTitle: "हमारी विरासत",
    aboutSubtitle: "तीन पीढ़ियों तक फैली शुद्धता की विरासत",
    aboutDesc: "50 से अधिक वर्षों से, राजदर्शन टंडन डेयरी रायपुर का विश्वसनीय शुद्ध दूध का स्रोत रहा है। हम पुरानी परंपराओं में विश्वास करते हैं – कोई पैकेजिंग नहीं, कोई प्रिजर्वेटिव नहीं, कोई शॉर्टकट नहीं। बस उन गायों से ईमानदार दूध जिन्हें हम परिवार मानते हैं।",
    aboutStat1: "500+",
    aboutStat1Label: "खुश परिवार",
    aboutStat2: "50+",
    aboutStat2Label: "वर्षों का विश्वास",
    aboutStat3: "100%",
    aboutStat3Label: "रसायन मुक्त",

    // Features Section
    featuresTitle: "राजदर्शन डेयरी को क्यों चुनें?",
    featuresSubtitle: "फर्क हमारी परंपरा में है",
    feature1Title: "बिना पैकेजिंग, शुद्ध डिलीवरी",
    feature1Desc: "हम पारंपरिक स्टील के कनस्तरों में ताजा दूध पहुंचाते हैं – जैसे आपके दादा-दादी को मिलता था। कोई प्लास्टिक नहीं, कोई टेट्रा पैक नहीं, बस शुद्धता।",
    feature2Title: "शून्य मिलावट",
    feature2Desc: "कोई प्रिजर्वेटिव नहीं, कोई रसायन नहीं, कोई पानी की मिलावट नहीं। जो हमारी गायों से आता है वह अपने शुद्धतम रूप में आपके दरवाजे तक पहुंचता है।",
    feature3Title: "उच्च प्रोटीन प्राकृतिक दूध",
    feature3Desc: "हमारी गायें प्राकृतिक चरागाहों में चरती हैं और उन्हें कभी हार्मोन नहीं दिए जाते। परिणाम? असाधारण पोषण मूल्य के साथ समृद्ध, मलाईदार दूध।",
    feature4Title: "पारंपरिक देसी तरीके",
    feature4Desc: "हाथ से दूध निकालने से लेकर स्टील के कनस्तर में डिलीवरी तक, हम उन पुरानी प्रथाओं का सम्मान करते हैं जो गुणवत्ता सुनिश्चित करती हैं।",

    // Cow Care Section
    cowCareTitle: "हमारी गायें परिवार हैं",
    cowCareSubtitle: "मशीन नहीं, बल्कि हमारे घर के प्यारे सदस्य",
    cowCareDesc: "राजदर्शन फार्म्स में, हम अपनी गायों की पूजा और देखभाल भक्ति के साथ करते हैं। वे हरे-भरे चरागाहों में स्वतंत्र रूप से घूमती हैं, सर्वोत्तम पोषण प्राप्त करती हैं, और प्यार और सम्मान के साथ व्यवहार किया जाता है। यह सिर्फ व्यवसाय नहीं है – यह पीढ़ियों से चली आ रही पवित्र जिम्मेदारी है।",
    cowCarePoint1: "प्राकृतिक चरागाहों में मुक्त चराई",
    cowCarePoint2: "नियमित पशु चिकित्सा देखभाल और ध्यान",
    cowCarePoint3: "कोई ग्रोथ हार्मोन या कृत्रिम चारा नहीं",
    cowCarePoint4: "पूजा और श्रद्धा के साथ व्यवहार",

    // Testimonials
    testimonialsTitle: "हमारे परिवारों का कहना है",
    testimonial1: "स्वाद मुझे गाँव के अपने बचपन की याद दिलाता है। आप गुणवत्ता में अंतर बता सकते हैं!",
    testimonial1Author: "प्रिया शर्मा",
    testimonial1Location: "सिविल लाइंस, रायपुर",
    testimonial2: "हमारे बच्चों के स्वास्थ्य के लिए सबसे अच्छा निर्णय। शुद्ध दूध, कोई समझौता नहीं।",
    testimonial2Author: "अमित वर्मा",
    testimonial2Location: "शंकर नगर, रायपुर",
    testimonial3: "15 साल से हमारे परिवार की सेवा कर रहे हैं। विश्वास और गुणवत्ता कभी कम नहीं हुई।",
    testimonial3Author: "रेखा जोशी",
    testimonial3Location: "देवेंद्र नगर, रायपुर",

    // CTA Section
    ctaTitle: "परंपरा की शुद्धता का अनुभव करें",
    ctaSubtitle: "रायपुर भर के 500+ परिवारों में शामिल हों जो अपनी दैनिक दूध की जरूरतों के लिए राजदर्शन पर भरोसा करते हैं",
    ctaButton: "अभी सब्सक्राइब करें",

    // Footer
    footerTagline: "1969 से शुद्धता की सेवा कर रहे हैं",
    footerAddress: "रायपुर, छत्तीसगढ़",
    footerContact: "संपर्क करें",
    footerPhone: "9039610400",
    footerRights: "© 2026 राजदर्शन टंडन डेयरी। सर्वाधिकार सुरक्षित।",
    footerDelivery: "प्यार और देखभाल के साथ पूरे रायपुर में डिलीवरी",
    footerSubscription: "हमारी सब्सक्रिप्शन सेवा",
    footerQuality: "हमारा दूध और गुणवत्ता",
    footerAreas: "रायपुर में डिलीवरी क्षेत्र",

    // Quality Page
    qualPageTitle: "A2 गाय और भैंस का दूध रायपुर – शुद्ध, बिना मिलावट",
    qualPageMeta: "राजदर्शन रायपुर में शुद्ध A2 गाय का दूध और भैंस का दूध देता है। कोई पानी की मिलावट नहीं, कोई रसायन नहीं। जानिए पैकेज्ड दूध की सच्चाई और क्यों लोकल डेयरी आपकी सबसे सुरक्षित पसंद है।",
    qualHeroBadge: "A2 गाय का दूध · भैंस का दूध · रायपुर",
    qualHeroTitle: "जो आप दूध समझकर पी रहे हैं, वो सच में दूध है?",
    qualHeroSubtitle: "भारत के पैकेज्ड दूध उद्योग का एक काला पहलू है। डिटर्जेंट। यूरिया। सिंथेटिक फैट। आपके परिवार को सच जानना चाहिए — और बेहतर पाने का हक है।",
    qualHeroCallBtn: "शुद्ध दूध के लिए फोन करें",
    qualHeroWhatsappBtn: "WhatsApp पर जानकारी पाएं",
    qualTruth: "भारतीय दूध की सच्चाई",
    qualTruthSubtitle: "भारत की अपनी खाद्य संस्था FSSAI द्वारा सत्यापित",
    qualStat1: "41%",
    qualStat1Label: "पैकेज्ड दूध के नमूने गुणवत्ता मानकों में फेल",
    qualStat1Src: "FSSAI राष्ट्रीय सर्वे 2018 (6,432 नमूने)",
    qualStat2: "38%",
    qualStat2Label: "2022 में दूध मिलावटी पाया गया",
    qualStat2Src: "FSSAI मिल्क सर्वेलेंस रिपोर्ट 2022",
    qualStat3: "12,000+",
    qualStat3Label: "2024-25 में दूध मिलावट के कानूनी केस",
    qualStat3Src: "India Today / FSSAI एनफोर्समेंट ड्राइव 2024",
    qualStat4: "500 लीटर",
    qualStat4Label: "1 लीटर रसायन से नकली दूध बनाया गया",
    qualStat4Src: "India Times – उत्तर प्रदेश गिरफ्तारी, 2024",
    qualCasesTitle: "असली मामले। असली खतरा।",
    qualCasesSubtitle: "ये अफवाहें नहीं हैं। ये सत्यापित, रिपोर्टेड तथ्य हैं।",
    qualMilkTitle: "हमारा दूध, सरल भाषा में",
    qualMilkSubtitle: "दो प्रकार का दूध। एक वादा: शुद्ध, प्राकृतिक और रासायन-मुक्त।",
    qualCow: "गाय का दूध",
    qualCowDesc: "हमारे फार्म में दो प्रकार की गायें हैं। हमारी देसी नस्लें — गिर, साहीवाल और थारपारकर — स्वाभाविक रूप से समृद्ध और शुद्ध दूध देती हैं जो आसानी से पचता है। इनके साथ-साथ हम उन गायों की भी देखभाल करते हैं जो प्राकृतिक रूप से A2 बीटा-केसीन प्रोटीन वाला दूध देती हैं — जो बच्चों, बुजुर्गों और संवेदनशील पाचन वालों के लिए आदर्श है।",
    qualCowTags: ["देसी नस्लें", "A2 उपलब्ध", "खुले चरागाह", "बच्चों के लिए श्रेष्ठ"],
    qualBuffalo: "भैंस का दूध",
    qualBuffaloDesc: "समृद्ध, मलाईदार और स्वाभाविक रूप से उच्च वसा — हमारा भैंस का दूध घी, पनीर, खोया और दही बनाने के लिए एकदम सही है। गाय के दूध से अधिक प्रोटीन और कैल्शियम।",
    qualBuffaloTags: ["उच्च वसा और प्रोटीन", "घी और पनीर के लिए श्रेष्ठ", "कैल्शियम से भरपूर", "खाना पकाने के लिए बढ़िया"],
    qualCareTitle: "हमारे दूध का स्वाद अलग क्यों है",
    qualCareSubtitle: "इसमें कोई जादू नहीं है। बस देखभाल है।",
    qualCare1: "मशीनें नहीं, परिवार के सदस्य",
    qualCare1Desc: "भारतीय परंपरा में गाय पवित्र है — गौ माता। हम इसी मान्यता से जीते हैं। हमारी गायों के नाम हैं। वे खुले चरागाहों में घूमती हैं।",
    qualCare2: "प्रीमियम चारा, खुली चराई",
    qualCare2Desc: "हमारे पशु प्राकृतिक घास पर चरते हैं और सर्वोत्तम प्राकृतिक चारा पाते हैं — कोई कृत्रिम योजक, हार्मोन या ग्रोथ एजेंट नहीं।",
    qualCare3: "कोई हार्मोन नहीं। कोई एंटीबायोटिक नहीं।",
    qualCare3Desc: "हम अपने पशुओं में ग्रोथ हार्मोन या नियमित एंटीबायोटिक कभी नहीं देते। कोई शॉर्टकट नहीं। कोई रसायन दूध में नहीं।",
    qualCare4: "2 घंटे में फार्म से घर तक",
    qualCare4Desc: "फार्म से निकला दूध 2 घंटे में आपके दरवाजे पर। कोई रेफ्रिजरेशन नहीं। कोई परिरक्षक नहीं।",
    qualWhyTitle: "लोकल डेयरी आपका सबसे सुरक्षित विकल्प क्यों है",
    qualWhyDesc: "बड़े पैकेज्ड दूध ब्रांड सैकड़ों किलोमीटर दूर हजारों फार्मों से दूध इकट्ठा करते हैं। जब तक वह आप तक पहुंचता है, वह परिवहन, चिल्ड, प्रोसेस, पाश्चराइज हो चुका होता है।",
    qualWhyPoint1: "फार्म से दरवाजे तक शून्य दूरी",
    qualWhyPoint2: "कोई प्रोसेसिंग नहीं जो पोषक तत्व नष्ट करे",
    qualWhyPoint3: "आप जानते हैं आपका दूध कहां से आता है",
    qualWhyPoint4: "55+ वर्षों से एक ही समुदाय के प्रति जवाबदेही",
    qualWhyPoint5: "हर लीटर के पीछे एक परिवार का नाम",
    qualCTATitle: "आपके परिवार को असली दूध मिलना चाहिए।",
    qualCTASubtitle: "शुद्ध A2 गाय का दूध और भैंस का दूध, हर सुबह रायपुर में आपके दरवाजे पर।",
    qualCTACall: "शुद्ध दूध के लिए कॉल करें",
    qualCTAWhatsapp: "अभी WhatsApp करें",

    // Subscription Page
    subPageTitle: "रोज़ाना दूध सब्सक्रिप्शन रायपुर",
    subPageMetaDesc: "राजदर्शन की रोज़ाना दूध डिलीवरी सब्सक्रिप्शन से जुड़ें। शुद्ध देसी दूध 2 घंटे में फार्म से घर तक।",
    subHeroTitle: "शुद्ध दूध। रोज़ डिलीवरी। स्मार्ट तरीके से।",
    subHeroSubtitle: "रायपुर की सबसे भरोसेमंद रोज़ाना दूध सब्सक्रिप्शन — हर सुबह और शाम देसी दूध आपके दरवाज़े पर।",
    subHeroBadge: "रोज़ाना दूध सब्सक्रिप्शन · रायपुर",
    subHeroCallBtn: "अभी सब्सक्राइब करें — फोन करें",
    subHeroWhatsappBtn: "WhatsApp पर शुरू करें",
    subTrustFamilies: "500+ परिवार",
    subTrustFamiliesLabel: "हम पर रोज़ भरोसा करते हैं",
    subTrustYears: "55+ साल",
    subTrustYearsLabel: "शुद्ध दूध का अनुभव",
    subTrustChemicals: "0 रसायन",
    subTrustChemicalsLabel: "कभी नहीं। गारंटी के साथ।",
    subTrustFresh: "< 2 घंटे",
    subTrustFreshLabel: "फार्म से आपके दरवाज़े तक",
    subHowTitle: "आपकी सब्सक्रिप्शन कैसे काम करती है",
    subHowSubtitle: "सरल। स्मार्ट। बिना झंझट के।",
    subStep1Title: "फोन या WhatsApp करें",
    subStep1Desc: "बताएं आपको कितना दूध चाहिए — सुबह, शाम या दोनों समय।",
    subStep2Title: "आपका खाता बन जाता है",
    subStep2Desc: "आपका निजी दूध खाता (लेजर) बन जाता है। एक खास सब्सक्रिप्शन लिंक मिलता है।",
    subStep3Title: "अपना निजी QR कोड पाएं",
    subStep3Desc: "हम आपको एक प्रिंटेड QR कार्ड देते हैं। जब दूधवाला आए, दिखा दें और दूध पाएं।",
    subStep4Title: "हर सुबह और शाम ताज़ा डिलीवरी",
    subStep4Desc: "फार्म से निकला शुद्ध देसी दूध, पारंपरिक स्टील कनस्तरों में भरकर, 2 घंटे के अंदर आपके घर पहुंच जाता है।",
    subStep5Title: "कभी भी बैलेंस देखें",
    subStep5Desc: "अपने निजी लिंक से देखें सब्सक्रिप्शन में कितना दूध बचा है।",
    subQRTitle: "आपका निजी QR — डिलीवरी पर पूरी आज़ादी",
    subQRSubtitle: "प्रिंटेड कार्ड या अपने फोन में। दिखाएं तो दूध मिले। न दिखाएं तो न मिले।",
    subQRPoint1: "हम आपको QR कोड देते हैं — प्रिंटेड कार्ड या मोबाइल पर सेव करें।",
    subQRPoint2: "दूधवाला आए → आप दिखाएं → दूध मिले। इतना सरल।",
    subQRPoint3: "दूध नहीं चाहिए? बस QR न दिखाएं — डिलीवरी नहीं, कोई कटौती नहीं।",
    subQRPoint4: "कोई कॉल नहीं। कोई रोक नहीं। पूरा कंट्रोल।",
    subQRHighlight: "आपका QR = आपका कंट्रोल। दिखाएं या न दिखाएं — हर डिलीवरी का फैसला आप करते हैं।",
    subFreshTitle: "2 घंटे से कम में फार्म से घर तक",
    subFreshSubtitle: "यही चीज़ राजदर्शन को हर पैकेज्ड ब्रांड से अलग बनाती है।",
    subFreshStep1: "फार्म में दूध निकाला",
    subFreshStep2: "स्टील कनस्तर में भरा",
    subFreshStep3: "डिलीवरी के लिए निकले",
    subFreshStep4: "आपके दरवाज़े पर",
    subFreshNote: "कोई फ्रिज नहीं। कोई प्रिजर्वेटिव नहीं। इतना ताज़ा दूध कि आप फार्म की महक महसूस करेंगे।",
    subBenefitsTitle: "सब्सक्रिप्शन में आपको क्या मिलता है",
    subBenefitsSubtitle: "पारंपरिक डेयरी के मूल्य। आज के ज़माने की सुविधा।",
    subBenefit1Title: "कोई ऐप नहीं",
    subBenefit1Desc: "एक सरल ब्राउज़र लिंक से सब मैनेज करें।",
    subBenefit2Title: "सुबह और शाम डिलीवरी",
    subBenefit2Desc: "दिन में दो बार ताज़ा दूध। अपने परिवार के हिसाब से समय चुनें।",
    subBenefit3Title: "लाइव बैलेंस देखें",
    subBenefit3Desc: "हमेशा पता रहे — सब्सक्रिप्शन में कितने लीटर दूध बचा है।",
    subBenefit4Title: "डिलीवरी पर पूरा कंट्रोल",
    subBenefit4Desc: "QR दिखाएं = दूध मिले। न दिखाएं = डिलीवरी नहीं।",
    subBenefit5Title: "खाता सिस्टम",
    subBenefit5Desc: "भरोसेमंद भारतीय प्रीपेड सिस्टम। एक बार रिचार्ज करें, बाकी सब हम संभालेंगे।",
    subBenefit6Title: "शून्य रसायन, शून्य समझौता",
    subBenefit6Desc: "100% शुद्ध देसी दूध। कोई पाश्चुरीकरण नहीं, कोई प्रिजर्वेटिव नहीं।",
    subFAQTitle: "अक्सर पूछे जाने वाले सवाल",
    subFAQ1Q: "सब्सक्राइब कैसे करें?",
    subFAQ1A: "बस 9039610400 पर कॉल या WhatsApp करें। हम आपकी मात्रा, समय और पता नोट करेंगे।",
    subFAQ2Q: "अगर किसी दिन दूध नहीं चाहिए तो?",
    subFAQ2A: "जब दूधवाला आए, बस QR कोड न दिखाएं। बैलेंस से एक बूंद भी नहीं कटेगी।",
    subFAQ3Q: "सब्सक्रिप्शन बैलेंस कैसे देखें?",
    subFAQ3A: "हम WhatsApp पर एक निजी लिंक भेजेंगे। किसी भी ब्राउज़र में खोलें।",
    subFAQ4Q: "क्या दिन में दो बार डिलीवरी हो सकती है?",
    subFAQ4A: "हां! हमारे कई ग्राहक सुबह और शाम दोनों डिलीवरी लेते हैं।",
    subFAQ5Q: "क्या मासिक पैकेज है या साप्ताहिक भी?",
    subFAQ5A: "हम एक लचीले खाता सिस्टम पर काम करते हैं। कोई लॉक-इन नहीं।",
    subCTATitle: "क्या आप शुद्ध दूध घर पर चाहते हैं?",
    subCTASubtitle: "रायपुर के 500+ परिवारों के साथ जुड़ें जो राजदर्शन की रोज़ाना होम डिलीवरी पर भरोसा करते हैं।",
    subCTACall: "सब्सक्राइब करने के लिए कॉल करें",
    subCTAWhatsapp: "अभी WhatsApp करें",
};

export default hi;
